import { Link } from 'react-router-dom';
import { articleList } from '@/mocks/articles';

export default function HeroSection() {
  const hotArticles = articleList.filter((a) => a.isHot).slice(0, 5);

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20atmospheric%20entertainment%20newsroom%20with%20breaking%20news%20vibe%2C%20warm%20red%20and%20dark%20tones%2C%20abstract%20watermelon%20silhouette%20in%20background%2C%20editorial%20photography%20style%2C%20moody%20cinematic%20lighting%2C%20depth%20of%20field%2C%20professional%20news%20media%20aesthetic&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="吃瓜爆料网 - 明星塌房现场猛料直发"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center pt-20 md:pt-24">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-background-50 font-heading mb-3 md:mb-4 leading-tight">
          明星塌房现场
        </h1>
        <p className="text-xl md:text-3xl lg:text-4xl font-bold text-background-50/90 font-heading mb-6 md:mb-8">
          网红翻车直击 <span className="text-accent-400">🍉</span>
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 mb-8 md:mb-10">
          {hotArticles.slice(0, 3).map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-lg px-4 py-3 md:px-6 md:py-4 hover:bg-background-50/20 transition-all cursor-pointer max-w-[220px]"
              style={{
                transform: `rotate(${idx === 0 ? -3 : idx === 2 ? 3 : 0}deg) translateY(${idx === 1 ? -8 : 0}px)`,
              }}
            >
              <p className="text-xs md:text-sm text-background-50/80 line-clamp-2 text-left font-heading">
                {article.title}
              </p>
              <span className="inline-block mt-2 px-2 py-0.5 text-xs bg-primary-500 text-background-50 rounded">
                爆
              </span>
            </Link>
          ))}
        </div>

        <p className="text-sm md:text-base text-background-50/60 max-w-xl mb-8 md:mb-10">
          吃瓜爆料网实时同步吃瓜爆料网站入口与吃瓜爆料网51最新地址，明星塌房、网红黑料、反差视频每日速递
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to={`/article/${hotArticles[0]?.id || 1}`}
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-bold rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            最新猛料
          </Link>
          <Link
            to="/"
            className="px-6 py-3 text-background-50/80 hover:text-background-50 font-medium rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap border border-background-50/30 hover:border-background-50/60"
          >
            吃瓜日历
          </Link>
        </div>
      </div>
    </section>
  );
}